import * as React from 'react';
import { SVGProps } from 'react';

const IconWifiWarningSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7 3a1 1 0 0 1 2 0v6c0 .056-.005.111-.013.165l-.003.012A1 1 0 0 1 7 9V3ZM10 9c0 .183-.024.36-.07.528.325.167.625.375.895.618l1.416-1.43A6.236 6.236 0 0 0 10 7.37V9ZM6.07 9.528A2.002 2.002 0 0 1 6 9V7.37a6.236 6.236 0 0 0-2.241 1.346l1.416 1.43c.27-.243.57-.45.895-.618ZM6 3.206v2.072a7.872 7.872 0 0 0-3.586 2.08L1 5.929a9.888 9.888 0 0 1 5-2.723ZM10 5.278V3.206a9.895 9.895 0 0 1 5 2.723l-1.414 1.428A7.872 7.872 0 0 0 10 5.278ZM8 11a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" />
  </svg>
);
export default IconWifiWarningSizeS;
